/*
 Check a la carte system : https://vuetifyjs.com/en/guides/a-la-carte#introduction
 */
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'

import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import colors from 'vuetify/es5/util/colors'
import Vue from 'vue'

Vue.use(Vuetify, {
  theme: {
    primary: colors.blue.darken1,
    mainHeader: colors.blue.darken3,
    secondary: '#424242',
    accent: '#82B1FF',
    error: colors.red.darken3,
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#fb8c00',
    disabled: colors.grey.lighten1
  },
  icons: {
    'circleCheckboxOn': 'check_circle',
    'circleCheckboxOff': 'radio_button_unchecked',
    'circleCheckboxIndeterminate': 'radio_button_checked'
  }
})
